import type {AgentProfile} from '../agent-profile'

/**
 * Shared profile base for remotable agents (CLI, VS Code, etc.).
 *
 * Remotable agents share these behaviors:
 * - Single session per task (header hidden, always expanded)
 * - Private sessions (no copy link)
 * - Agent provides its own intent (no synthetic status messages)
 * - Interactive session with optimistic logs and raw command display
 *
 * Each concrete profile adds: slug, displayName, agentInfo, and all slots
 * (LeadingIcon, ChatInput, EmptyState). Slots are defined per-profile to
 * avoid circular dependency issues with component imports.
 */
export const REMOTABLE_BASE: Partial<AgentProfile> = {
  singleSessionAgent: true,
  privateSessions: true,

  agentProvidesIntent: true,
  interactiveSession: true,
  enableAgentGrouping: true,

  secondaryLabel: 'Remote session',
}
